module.exports = __webpack_public_path__ + "static/media/Group 1306.a78b8e05.svg";